/* eslint-disable @typescript-eslint/no-explicit-any */
import { customersAuthorizationApi } from '../api';
import { EndpointsMvp } from './enum';
import { useAuth } from './useAuth';

interface SalesAgreementData {
  salesAgreement: string;
  expirationDate: string;
  paymentTerms: string;
  paymentTermsDescription: string;
  destination: string;
  agreementUm: string;
}

export interface PricingItem {
  item: string;
  product: string;
  creditPrice: string;
  um: string;
  paymentTerms: string;
  paymentTermsDescription: string;
  destination: string;
  destinationDescription: string;
  isAgreementPrice: string;
  salesAgreementData: SalesAgreementData;
}

interface PricingResponse {
  pricing: PricingItem[];
}

export const usePurchaseForHistoricService = () => {
  const { getHeaders } = useAuth();
  const headers = getHeaders();

  const getPurchaseHistoric = async (
    customer: string,
    hidePrice: boolean
  ): Promise<any> => {
    try {
      const response = await customersAuthorizationApi.get(
        `${EndpointsMvp.FETCH_PURCHASE_HISTORIC(customer, hidePrice)}`,
        { headers }
      );

      const purchaseProductForHistoric = response.data;
      return purchaseProductForHistoric;
    } catch (error) {
      console.error('Erro na compra por histórico', error);
      throw error;
    }
  };

  const productPricing = async (
    shipTo: string,
    soldTo: string,
    products: { product: string; quantity: string; um: string }[]
  ): Promise<PricingResponse> => {
    const items = products.map(({ product }) => ({
      product,
      quantity: '',
      um: ''
    }));
    const body = {
      soldTo: soldTo,
      shipTo: shipTo,
      items: items
    };
    try {
      const response = await customersAuthorizationApi.post(
        `${EndpointsMvp.PRODUCT_PRICING}`,
        body,
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error('Erro na compra por histórico', error);
      throw error;
    }
  };

  return {
    getPurchaseHistoric,
    productPricing
  };
};
